/**
 * Mobile-only top bar (<lg).
 * Shows brand + language switcher dropdown + account/menu access
 * (Grammatica + Instellingen reachable via the account link to /settings).
 */
import { NavLink } from "react-router";
import { Spreekballon } from "../Spreekballon";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { useT } from "../../lib/use-t";

type MobileTopBarProps = {
  displayName: string;
};

export function MobileTopBar({ displayName }: MobileTopBarProps) {
  const t = useT();
  const initial = displayName.trim().charAt(0).toUpperCase() || "?";

  return (
    <header className="lg:hidden flex items-center gap-2.5 px-[18px] py-4 bg-[var(--bg)] border-b border-[var(--border)]">
      {/* Brand */}
      <NavLink to="/vandaag" className="flex items-center gap-2 shrink-0">
        <Spreekballon size={24} />
        <span className="font-display font-semibold text-[17px] tracking-tight leading-none">
          <span className="text-[var(--accent)]">A2</span>
          {" "}Easy
        </span>
      </NavLink>

      <div className="flex-1" />

      {/* Language switcher (dropdown variant on mobile) */}
      <LanguageSwitcher variant="topbar" />

      {/* Account avatar — links to /settings (Instellingen + Grammatica accessible there) */}
      <NavLink
        to="/settings"
        aria-label={t("chrome.nav.accountSettingsAriaLabel")}
        className="w-8 h-8 rounded-full bg-[var(--accent)] text-white flex-none grid place-items-center font-mono-badge text-xs font-semibold hover:opacity-90 transition-opacity focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)] focus-visible:outline-offset-2"
      >
        {initial}
      </NavLink>
    </header>
  );
}
